import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// transport failure: the request never got a response from the backend (offline, CORS, timeout).
// surfaced globally in the store middleware, unless the call site asked to speak for itself
// (see `handlesOwnTransportError` on TUploadFileArg), so per-feature handlers skip their own
// toast for these.
export const isTransportError = (
  payload: unknown,
): payload is FetchBaseQueryError =>
  typeof payload === 'object' &&
  payload !== null &&
  'status' in payload &&
  (payload.status === 'FETCH_ERROR' || payload.status === 'TIMEOUT_ERROR');
